import { IRecipient, IDonor, ICompatibilityResult } from '@nkr/models/index';
import { Button, Panel } from 'react-bootstrap';
import { ActionItems } from './action-items';

interface IProps {
    donor: IDonor,
    recipient: IRecipient,
    compatibilityResult: ICompatibilityResult,
    includeButtons: boolean,
    doesStudyExist: number,
    onActionItem: (item: ActionItems) => void,
    onViewCtScan: (donorId: number) => void
}

const AdditionalDonorInfo = (props: IProps) => {
    const getBloodPressure = () => {
        if (props.compatibilityResult.donor.bloodPressure == 1)
            return 'No Hypertension';

        if (props.compatibilityResult.donor.bloodPressure == 2)
            return 'Mild Hypertension';

        if (props.compatibilityResult.donor.bloodPressure == 3)
            return 'Hypertensive w/o Medications';

        if (props.compatibilityResult.donor.bloodPressure == 4)
            return 'Hypertensive w/ Medications';

        if (props.compatibilityResult.donor.bloodPressure == 5)
            return 'Not Hypertensive w/ Medications';
    };

    const handleCtView = (donorId: number) => {
        props.onViewCtScan(donorId);
    };

    const { donor, recipient, includeButtons, doesStudyExist } = props;

    return (
        <Panel className='additional-donor-info'>
            <Panel.Heading><span className='heading medium'>Additional Donor Information</span></Panel.Heading>
            <Panel.Body>
                <div className='row' style={{ marginBottom: 10 }}>
                    <div className='col-xs-2'><strong>Donor Registered:</strong></div>
                    <div className='col-xs-2'>{donor.dateRegistered}</div>
                    <div className='col-xs-2'><strong>Donor Is Active?</strong></div>
                    <div className='col-xs-2'>{donor.isActive ? 'Yes' : 'No'}</div>
                </div>

                <div className='row' style={{ marginBottom: 20 }}>
                    <div className='col-xs-2'><strong>24 Hour Urine Protein:</strong></div>
                    <div className='col-xs-2'>{donor.urineProtein}</div>
                    <div className='col-xs-2'><strong>Albumin Excretion:</strong></div>
                    <div className='col-xs-2'>{donor.albuminExcretion}</div>
                    <div className='col-xs-2'><strong>Blood Pressure:</strong></div>
                    <div className='col-xs-2'>{getBloodPressure()}</div>
                </div>

                <div className='row print-break' style={{ marginBottom: donor.vrlHlaUploadPath != '' && includeButtons ? 20 : 0 }}>
                    <div className='col-xs-12'>
                        <p>
                            <b>Medical Notes and Additional Tests</b><br />
                            {donor.medicalComments != '' ? donor.medicalComments : 'No Comments'}
                        </p>
                        <p>
                            <b>24 Hour BP Monitor</b><br />
                            {donor.bp24Hour != '' ? donor.bp24Hour : 'No Comments'}
                        </p>
                        <p>
                            <b>Donor Abnormalities</b><br />
                            {donor.donorCtAbnormalities != '' ? donor.donorCtAbnormalities : 'No Comments'}
                        </p>
                        <p style={{ marginBottom: 0 }}>
                            <b>Donor Reports:&nbsp;</b>

                            {doesStudyExist >= 1 && includeButtons == false && (
                                <>
                                    <a className='btn btn-primary' style={{ fontSize: 12, fontWeight: 'bold', width: 200, margin: '5px 2px' }} onClick={() => handleCtView(donor.id)} >View Donor CT Study</a>
                                </>
                            )}

                            <Button bsStyle='primary' bsSize='sm' onClick={() => props.onActionItem(ActionItems.DonorCTReport)} target='_blank'>Download Donor CT Report</Button>

                            {donor.vrlHlaUploadPath != '' && includeButtons == false && (
                                <Button bsStyle='primary' bsSize='sm' onClick={() => props.onActionItem(ActionItems.VRLConfirmatoryTypingReport)} target='_blank'>Download VRL Confirmatory Typing Report</Button>
                            )}
                        </p>
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default AdditionalDonorInfo;